import React from "react";
import { Box, Typography } from "@mui/material";
// @ts-ignore
import { isEmpty } from "lodash";

const PageHeader: React.FC<{
  headerText: React.ReactNode;
  subHeaderText: React.ReactNode;
}> = ({ headerText, subHeaderText }) => {
  const isNoHeaders = isEmpty(headerText) && isEmpty(subHeaderText);
  return (
    <>
      <Box
        sx={{
          position: "relative",
          color: "#FFE263",
          padding: isNoHeaders ? "0px" : "16px 16px",
          marginBottom: isNoHeaders ? "0px" : "16px"
        }}
      >
        {headerText && (
          <Typography variant="h4" textAlign={"center"}>
            {headerText}
          </Typography>
        )}
        {subHeaderText && (
          <Typography
            variant="subtitle1"
            textAlign={"center"}
            sx={{ opacity: 0.9, fontWeight: 500, color: "#FFF" }}
          >
            {subHeaderText}
          </Typography>
        )}
      </Box>
    </>
  );
};

export default PageHeader;
